module.exports = __webpack_public_path__ + "img/content1.e620dda3.png";